import { configureStore } from '@reduxjs/toolkit';
import appReducer from './Slices/App/appSlice';
import headerReducer from './Slices/Header/headerSlice';
import MessageReducer from './Slices/Header/messageSlice';
import homeReducer from './Slices/Home/homeSlice';
import commonSlice from './Slices/commonSlice';
import retroReducer from 'Slices/Retro/retroSlice';
import permissionReducer from 'Slices/Permission/permissionSlice';
import menuThemeReducer from './Slices/MenuManagement/menuThemeSlice';
import requestsReducer from 'Slices/Requests/requestsSlice';
import workflowSyncReducer from 'Slices/Requests/workflowSyncSlice';
import billingAnalysisReducer from './Slices/BillingAnalysis/billingAnalysisSlice';

export default configureStore({
  reducer: {
    app: appReducer,
    header: headerReducer,
    message: MessageReducer,
    home: homeReducer,
    common: commonSlice,
    retro: retroReducer,
    permission: permissionReducer,
    menuTheme: menuThemeReducer,
    requests: requestsReducer,
    workflowSync: workflowSyncReducer,
    billingAnalysis: billingAnalysisReducer
  }
});
